/* tslint:disable */
/* eslint-disable */
/**
 * Respa
 * The Respa API provides categorized data on resources available for reservation within a city or metropolitan area and enables the reservation of these resources. The API provides data in the JSON format, in a RESTful fashion.
 *
 * The version of the OpenAPI document: 1.6.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LocalizedString
 */
export interface LocalizedValue {
    /**
     * Localized in Finnish
     * @type {string}
     * @memberof LocalizedValue
     */
    fi?: string;
        /**
     * Localized in English
     * @type {string}
     * @memberof LocalizedValue
     */
    en?: string;
        /**
     * Localized in Swedish
     * @type {string}
     * @memberof LocalizedValue
     */
    sv?: string;
}

export function LocalizedValueFromJSON(json: any): LocalizedValue {
    return LocalizedValueFromJSONTyped(json, false);
}

export function LocalizedValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): LocalizedValue {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fi': !exists(json, 'fi') ? undefined : json['fi'],
        'en': !exists(json, 'en') ? undefined : json['en'],
        'sv': !exists(json, 'sv') ? undefined : json['sv'],
    };
}

export function LocalizedValueToJSON(value?: LocalizedValue | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fi': value.fi,
        'en': value.en,
        'sv': value.sv,
    };
}
